module.exports = __webpack_public_path__ + "img/15.412063e4.png";